import { IIconProps } from './add';

export const IcoArrowDownFilled: React.FC<IIconProps> = ({ style, cy }) => (
  <svg
    width="11"
    height="17"
    viewBox="0 0 11 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    data-cy={`IcoArrowDownFilled${cy}`}
  >
    <path
      d="M5.5 17L11 12.155L6.875 12.155L6.875 -3.60619e-07L4.125 -6.01032e-07L4.125 12.155L4.23563e-07 12.155L5.5 17ZM5.5 17L11 12.155L6.875 12.155L6.875 -3.60619e-07L4.125 -6.01032e-07L4.125 12.155L4.23563e-07 12.155L5.5 17Z"
      fill="currentColor"
    />
  </svg>
);
